import TenantHandlerInterfaceV1 from './TenantHandlerInterfaceV1';
import * as T from '@clientos/types';

export { createNoopTenantHandlerInterface } from './NoopInterface';

let tenantHandlerInterfaceV1: T.TenantHandlerInterfaceType;

export default async function initializeTenantHandlerInterfaceSingleton(): Promise<T.TenantHandlerInterfaceType> {
  if (tenantHandlerInterfaceV1) return tenantHandlerInterfaceV1;

  tenantHandlerInterfaceV1 = new TenantHandlerInterfaceV1();

  return tenantHandlerInterfaceV1;
}
